<template>
  <v-col>
    <v-row align="center" justify="between" pb-4>
      <h4 style="padding-right: 64px">Driver App Permissions</h4>
    </v-row>
    <v-flex pt-2>
      <v-card>
        <v-card-text>
          <div>
            <div>
              Battery Saver: {{ this.getHumanReadablePermissionState(permissions.battery_saver) }}
            </div>
            <div>
              Battery Percentage: {{ permissions.battery_percentage }}
            </div>
            <div>
              Background Permissions: {{ this.getHumanReadablePermissionState(permissions.background_permission) }}
            </div>
            <div>
              Notification Permission: {{ this.getHumanReadablePermissionState(permissions.notification_permission) }}
            </div>
            <div>
              Location Access: {{ this.getHumanReadablePermissionState(permissions.location) }}
            </div>
            <div>
              Location Always On: {{ this.getHumanReadablePermissionState(permissions.location_always) }}
            </div>
            <div>
              Location In Use: {{ this.getHumanReadablePermissionState(permissions.location_in_use) }}
            </div>
            <div>
              Camera Permissions: {{ this.getHumanReadablePermissionState(permissions.camera) }}
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-col>
</template>

<script>

import axios from "axios";

export default {
  name: "DriverPermissions",
  props: {
    driver: Object,
  },
  data: function () {
    return {
      permissions: Object,
    };
  },
  mounted: async function () {
    this.getDriverAppPermissions();
  },
  methods: {
    getHumanReadablePermissionState: function (permissionValue){
      if(permissionValue === true){
        return "Enabled";
      }
      else if(permissionValue === false){
        return "Disabled";
      }
      else return "Unknown";
    },
    getDriverAppPermissions: async function () {
      try {
        var url = `${this.$store.state.apiUrl}/driver/${this.driver.id}/permissions`;

        let response = await axios.get(url, {
          params: {},
        });

        this.permissions = response.data.permissions.permissions;
      } catch (error) {
        console.log("Failed to get driver " + error);
      }
    },
  }
}

</script>